import { faRetweet } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useAtendimentoPage } from "../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../Context/Historico";
import { AlterarEtapaManualmenteController } from "../../../Controllers/Geral/AcaoEtapa/AcaoEtapaControllers";
import { ListarEtapasPorCategoriaAtendimentoETipoCasoController } from "../../../Controllers/Geral/Etapas/EtapasControllers";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { IListarEtapas } from "../../../Interfaces/Geral/Etapas/EtapasInterfaces";
import UnForm from "../../Form";

interface IAlterarEtapaCasoProps {
    setShow: (show: boolean) => void;
    updateAtendimento: () => void;
}

export default function AlterarEtapaCaso(props: IAlterarEtapaCasoProps) {
    const [etapas, setEtapas] = useState<Array<IListarEtapas>>([]);

    const { ID_CASO, idModulo } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const { execute: alterarEtapa, loading: alterarEtapaLoading } =
        useAsyncCallback(AlterarEtapaManualmenteController);

    const { execute: listarEtapas } = useAsyncCallback(
        () =>
            ListarEtapasPorCategoriaAtendimentoETipoCasoController(
                ID_CASO,
                idModulo
            ),
        []
    );

    useEffect(() => {
        if (ID_CASO) {
            listarEtapas().then((res) => {
                res.sort(
                    (a, b) =>
                        (a.NR_ETAPA
                            ? a.NR_ETAPA
                            : a.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO) -
                        (b.NR_ETAPA
                            ? b.NR_ETAPA
                            : b.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO)
                );
                setEtapas(res);
            });
        }
    }, [ID_CASO, listarEtapas]);

    function handleAlterarEtapa(formData: {
        justificativa: string;
        novaEtapa: number;
    }) {
        alterarEtapa(ID_CASO, formData.novaEtapa, formData.justificativa).then(
            () => {
                props.updateAtendimento();
                props.setShow(false);
                ReloadHistorico();
            }
        );
    }

    return (
        <UnForm handleSubmit={handleAlterarEtapa}>
            <UnForm.Select
                label="Etapa"
                name="novaEtapa"
                registerOptions={{ required: "Selecione uma etapa" }}
            >
                <option></option>
                {etapas?.map((etapa) => (
                    <option
                        value={
                            etapa.ID_ETAPA_TIPO_CASO
                                ? etapa.ID_ETAPA_TIPO_CASO
                                : etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                        }
                    >
                        {etapa.DS_ETAPA
                            ? etapa.DS_ETAPA
                            : etapa.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}
                    </option>
                ))}
            </UnForm.Select>
            <UnForm.Textarea
                label="Justificativa"
                name="justificativa"
                registerOptions={{ required: "Insira uma justificativa" }}
            />
            <UnForm.SubmitButton
                loading={alterarEtapaLoading}
                wrapperClassName="d-flex col-12 justify-content-end mt-3 mr-0 p-0"
                disabled={alterarEtapaLoading}
                className="col-12"
                icon={faRetweet}
                color="success"
                loadingSize="sm"
            >
                Alterar Etapa
            </UnForm.SubmitButton>
        </UnForm>
    );
}
